const config = {
    backendUrl: process.env.NODE_ENV === 'production'
        ? 'https://api.sponsor-db.com/api/'
        : 'http://localhost:3001/api/',
};

export default config; 